
import { useState } from 'react';
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const FaqHero = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const { ref: heroRef, isVisible: heroVisible } = useScrollAnimation({ threshold: 0.1 });

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const el = document.getElementById('faq-content');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    window.dispatchEvent(new CustomEvent('faq-search', { detail: searchTerm }));
  };

  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1a1483dc89563faeb7d0310a6755b25e.jpg"
          alt="Preguntas frecuentes sobre desguace en Gavá"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div ref={heroRef} className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-center w-full">
        <nav
          className={`mb-8 transition-all duration-600 ${
            heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-6'
          }`}
          aria-label="Breadcrumb"
        >
          <ol className="flex items-center justify-center space-x-2 text-sm text-white/70">
            <li><a href="/" className="hover:text-white transition-colors">Inicio</a></li>
            <li><i className="ri-arrow-right-s-line"></i></li>
            <li className="text-emerald-400 font-medium">Preguntas Frecuentes</li>
          </ol>
        </nav>

        <div
          className={`inline-flex items-center space-x-2 bg-emerald-600/90 backdrop-blur-sm text-white px-5 py-2 rounded-full mb-6 transition-all duration-700 delay-100 ${
            heroVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-75'
          }`}
        >
          <i className="ri-question-answer-fill text-lg"></i>
          <span className="text-sm font-medium">+35 Preguntas Resueltas</span>
        </div>

        <h1
          className={`text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight transition-all duration-700 delay-200 ${
            heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-8'
          }`}
        >
          Preguntas Frecuentes sobre<br />
          <span className="text-emerald-400">Desguace en Gavá</span>
        </h1>

        <p
          className={`text-lg md:text-xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed transition-all duration-700 delay-300 ${
            heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Resolvemos todas tus dudas sobre <strong>venta de coches siniestrados</strong>, documentación, precios, recogida gratuita y más. Todo lo que necesitas saber sobre nuestro <strong>desguace en Gavá</strong>.
        </p>

        <form
          onSubmit={handleSearch}
          className={`max-w-2xl mx-auto relative transition-all duration-700 delay-[400ms] ${
            heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="relative">
            <i className="ri-search-line absolute left-5 top-1/2 -translate-y-1/2 text-gray-400 text-xl"></i>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Buscar tu pregunta... (ej: documentación, precio, grúa)"
              className="w-full pl-14 pr-36 py-5 rounded-2xl bg-white text-gray-900 text-base placeholder-gray-400 shadow-2xl focus:outline-none focus:ring-2 focus:ring-emerald-500"
            />
            <button
              type="submit"
              className="absolute right-3 top-1/2 -translate-y-1/2 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-xl font-semibold text-sm transition-all whitespace-nowrap cursor-pointer"
            >
              Buscar
            </button>
          </div>
        </form>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default FaqHero;
